import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'app-resume',
    templateUrl: './resume.component.html',
    styleUrls: ['./resume.component.scss'],
    standalone: false
})
export class ResumeComponent {

  constructor(private activeModal: NgbActiveModal) { }

  close(resume: boolean) {
    if (!resume) {
      document.cookie = 'permittingtoken=; Max-Age=-99999999;';
    }
    this.activeModal.close(resume);
  }
}
